export const INSIGHTS_GROUP_BREAKDOWNS_AD_THRESHOLD = 50;
